<template>
  <div class="table-random-generator-activated">
    <i class="far fa-info-circle info-icon" />
    <span class="viewing-date">
      {{ randomPeopleViewing.date }}
    </span>
    <span>
      {{ 'admin_random_generator_was_used' | translate }}
    </span>
    <span
      v-for="appointment in randomPeopleViewing.appointments"
      :key="appointment.key"
      class="public-link pointer"
      @click="openPublicLink(appointment.key)">
      {{ appointment.displayName }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'TableRandomGeneratorActivated',
  props: {
    randomPeopleViewing: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openPublicLink(key) {
      window.open(`${window.location.origin}/action/${key}/appointment-edit-participants`, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.table-random-generator-activated {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 7.5px 12px;
  border-radius: 4px;
  margin-bottom: 20px;
  color: $color-text-secondary;
  background-color: $color-back-light;
  font-size: 14px;

  .info-icon {
    margin-right: 8px;
    font-size: 16px;
  }

  .viewing-date {
    margin-right: 5px;
    font-weight: $font-weight-bold;
  }

  .public-link {
    padding-left: 8px;
    margin-left: 8px;
    color: $color-text-important;
    font-weight: $font-weight-bold;
  }
}
</style>
